import { AxiosInstance } from 'axios'

import { createAuthedHttpClient } from '@driftt/web-auth'

import config from 'config'

export const MetricsApi: AxiosInstance = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.METRICS_API
  }
})

export const AudiencesApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: window.DRIFT_CONFIG.LIVE_API
  }
})
